import { ContentType } from 'types/publishedAssets';
import { ImageGallerySlideshow } from './ImageGallerySlideshow';
import { ImageGalleryGrid } from './ImageGalleryGrid';

interface ImageGalleryProps {
  content: ContentType;
}

export function ImageGallery({ content }: ImageGalleryProps) {
  const type = content.display_type;
  if (type === 'image_slideshow') {
    return <ImageGallerySlideshow content={content} />;
  }
  return <ImageGalleryGrid content={content} />;
}
